import { FC } from 'react';
import clsx from 'clsx';
import ContextMenu, { type IContextMenuProps } from '../../molecules/ContextMenu';
import { DTB_POPUP_Z } from '../popupZIndex';
import { IDataTableMenuEntry } from '../DataTable.types';

interface DataTableContextMenuProps extends Pick<
    IContextMenuProps,
    'opened' | 'point' | 'onClose' | 'openedBy' | 'returnFocus'
> {
    entries: IDataTableMenuEntry[];
}

/** Контекстное меню шапки и строки — `ContextMenu` пакета со своим видом пунктов (`.dtb-ctx`, контракт стилей таблицы). */
const DataTableContextMenu: FC<DataTableContextMenuProps> = ({ entries, onClose, ...menu }) => (
    <ContextMenu {...menu} onClose={onClose} zIndex={DTB_POPUP_Z} className="dtb-menu dtb-ctx" data-testid="dtb-ctx">
        {entries.map((e) =>
            e.divider ? (
                <hr key={e.key} />
            ) : (
                <button
                    key={e.key}
                    type="button"
                    role="menuitem"
                    tabIndex={-1}
                    className={clsx('dtb-ctx__item', e.danger && 'is-danger')}
                    disabled={e.disabled}
                    onClick={() => {
                        e.onClick?.();
                        onClose();
                    }}
                >
                    {e.icon && (
                        <span className="dtb-ctx__icon" aria-hidden="true">
                            {e.icon}
                        </span>
                    )}
                    {e.label}
                </button>
            ),
        )}
    </ContextMenu>
);

export default DataTableContextMenu;
